/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GammaShortStrategy,
  GammaShortStrategyInterface,
} from "../GammaShortStrategy";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "T",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "delta",
        type: "int256",
      },
    ],
    name: "DeltaHedged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositedAmount",
        type: "uint256",
      },
    ],
    name: "DepositedToStrategy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "hedgeInterval",
        type: "uint256",
      },
    ],
    name: "HedgeIntervalUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "hedgeSqrtPriceThreshold",
        type: "uint256",
      },
    ],
    name: "HedgePriceThresholdUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newHedgerAddress",
        type: "address",
      },
    ],
    name: "HedgerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "OperatorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newReaderAddress",
        type: "address",
      },
    ],
    name: "ReaderUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pairId",
        type: "uint256",
      },
    ],
    name: "StrategyAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "strategyTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
    ],
    name: "WithdrawnFromStrategy",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burnStrategyToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
    ],
    name: "checkPriceHedge",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
    ],
    name: "checkTimeHedge",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_strategyTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recepient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxDepositAmount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isQuoteMode",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "finalDepositMargin",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_pairId",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "_initialMarginAmount",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "_initialPerpAmount",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "_initialSquartAmount",
        type: "int256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_sqrtPriceThreshold",
        type: "uint256",
      },
    ],
    name: "depositForPositionInitialization",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_deltaRatio",
        type: "uint256",
      },
    ],
    name: "execDeltaHedge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
    ],
    name: "getDelta",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
    ],
    name: "getTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "hedger",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_controller",
        type: "address",
      },
      {
        internalType: "address",
        name: "_reader",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lower",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upper",
            type: "uint256",
          },
        ],
        internalType: "struct BaseStrategy.MinPerValueLimit",
        name: "_minPerValueLimit",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "operator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "perpEntryUpdate",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "sqrtEntryUpdate",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "sqrtRebalanceEntryUpdateUnderlying",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "sqrtRebalanceEntryUpdateStable",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "perpPayoff",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "sqrtPayoff",
                type: "int256",
              },
            ],
            internalType: "struct Perp.Payoff",
            name: "payoff",
            type: "tuple",
          },
          {
            internalType: "int256",
            name: "fee",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "minDeposit",
            type: "int256",
          },
        ],
        internalType: "struct DataType.TradeResult",
        name: "_tradeResult",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "predyTradeCallback",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reader",
    outputs: [
      {
        internalType: "contract Reader",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "_ratio",
        type: "int256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
    ],
    name: "refresh",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
    ],
    name: "reset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newHedger",
        type: "address",
      },
    ],
    name: "setHedger",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOperator",
        type: "address",
      },
    ],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_reader",
        type: "address",
      },
    ],
    name: "setReader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "strategies",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "pairGroupId",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "pairId",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "marginToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "marginRoundedScaler",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "strategyToken",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lastHedgeTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastHedgePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "hedgeInterval",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "hedgeSqrtPriceThreshold",
            type: "uint256",
          },
        ],
        internalType: "struct BaseStrategy.HedgeStatus",
        name: "hedgeStatus",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "strategyCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "_sqrtAmount",
        type: "int256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
    ],
    name: "updateGamma",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_hedgeInterval",
        type: "uint256",
      },
    ],
    name: "updateHedgeInterval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_newSqrtPriceThreshold",
        type: "uint256",
      },
    ],
    name: "updateHedgePriceThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_strategyId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_withdrawStrategyAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recepient",
        type: "address",
      },
      {
        internalType: "int256",
        name: "_minWithdrawAmount",
        type: "int256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lowerSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "upperSqrtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IStrategyVault.StrategyTradeParams",
        name: "_tradeParams",
        type: "tuple",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "finalWithdrawAmount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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$cd710f183e134f2ed60fc4ce33900e1b11$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";

type GammaShortStrategyConstructorParams =
  | [linkLibraryAddresses: GammaShortStrategyLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GammaShortStrategyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class GammaShortStrategy__factory extends ContractFactory {
  constructor(...args: GammaShortStrategyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        GammaShortStrategy__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: GammaShortStrategyLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$cd710f183e134f2ed60fc4ce33900e1b11\\$__", "g"),
      linkLibraryAddresses[
        "src/strategy/base/DeployStrategyTokenLogic.sol:DeployStrategyTokenLogic"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GammaShortStrategy> {
    return super.deploy(overrides || {}) as Promise<GammaShortStrategy>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): GammaShortStrategy {
    return super.attach(address) as GammaShortStrategy;
  }
  connect(signer: Signer): GammaShortStrategy__factory {
    return super.connect(signer) as GammaShortStrategy__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GammaShortStrategyInterface {
    return new utils.Interface(_abi) as GammaShortStrategyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GammaShortStrategy {
    return new Contract(address, _abi, signerOrProvider) as GammaShortStrategy;
  }
}

export interface GammaShortStrategyLibraryAddresses {
  ["src/strategy/base/DeployStrategyTokenLogic.sol:DeployStrategyTokenLogic"]: string;
}
